import baseIsMatch from "./component-library324.mjs";
import getMatchData from "./component-library325.mjs";
import matchesStrictComparable from "./component-library326.mjs";
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
export {
  baseMatches as default
};
